// Shared between GuidancePage (initial request) and GuidanceRespond (resubmit
// after a decline) — both let a visitor suggest either an exact time or a
// time range per slot, so Pooja has more room to find something that works
// without a decline/resubmit round trip.

export const MIN_SESSION_MINUTES = 30;

export const emptyTime = () => ({ type: "exact", date: "", time: "", startTime: "", endTime: "" });

export function minutesOf(hhmm) {
  const [h, m] = String(hhmm || "").split(":").map(Number);
  return h * 60 + m;
}

export function subtractMinutes(hhmm, mins) {
  const total = Math.max(0, minutesOf(hhmm) - mins);
  return `${String(Math.floor(total / 60)).padStart(2, "0")}:${String(total % 60).padStart(2, "0")}`;
}

export const isSlotFilled = (t) =>
  t.type === "range" ? !!(t.date && t.startTime && t.endTime) : !!(t.date && t.time);

export const isSlotWideEnough = (t) =>
  t.type !== "range" || (minutesOf(t.endTime) - minutesOf(t.startTime) >= MIN_SESSION_MINUTES);

export const isSlotBlocked = (t, blocked) =>
  t.type === "range"
    ? blocked.some(b => b.date === t.date && !b.time)
    : blocked.some(b => b.date === t.date && (!b.time || b.time === t.time));

export const buildProposedTimes = (times, maxTimes) =>
  times.filter(isSlotFilled).slice(0, maxTimes).map(t =>
    t.type === "range"
      ? { type: "range", date: t.date, startTime: t.startTime, endTime: t.endTime }
      : { type: "exact", date: t.date, time: t.time }
  );
